import * as actions from "./actions";
import { initialState } from "../reducer";

export function smeSubreducer(state = initialState, action) {
  switch (action.type) {
    case actions.SME_CREATE_REQUEST:
      return Object.assign({}, state, {
        SME: Object.assign({}, state.SME, {
          applicationCreate: Object.assign({}, state.SME.applicationCreate, {
            sent: false,
            sending: true,
          }),
        }),
      });
    case actions.SME_CREATE_SUCCESS:
      return Object.assign({}, state, {
        SME: Object.assign({}, state.SME, {
          applicationCreate: Object.assign({}, state.SME.applicationCreate, {
            sent: true,
            sending: false,
            error: null,
          }),
        }),
      });
    case actions.SME_CREATE_ERROR:
      return Object.assign({}, state, {
        SME: Object.assign({}, state.SME, {
          applicationCreate: Object.assign({}, state.SME.applicationCreate, {
            sent: false,
            sending: false,
            error: action.error,
          }),
        }),
      });
    // Fetching of data
    case actions.GET_SME_APPLICATIONS_REQUEST:
      return Object.assign({}, state, {
        SME: Object.assign({}, state.SME, {
          application: Object.assign({}, state.SME.application, {
            fetching: true,
            error: null,
            data: [],
          }),
        }),
      });
    case actions.GET_SME_APPLICATIONS_SUCCESS:
      return Object.assign({}, state, {
        SME: Object.assign({}, state.SME, {
          application: Object.assign({}, state.SME.application, {
            fetching: false,
            error: null,
            data: action.response,
          }),
        }),
      });
    case actions.GET_SME_APPLICATIONS_ERROR:
      return Object.assign({}, state, {
        SME: Object.assign({}, state.SME, {
          application: Object.assign({}, state.SME.application, {
            fetching: false,
            error: action.error,
          }),
        }),
      });
    // Other
    case actions.SME_LIST_CHANGE_PAGE:
      return Object.assign({}, state, {
        SME: Object.assign({}, state.SME, {
          application: Object.assign({}, state.SME.application, {
            table: Object.assign({}, state.SME.application.table, {
              pagination: Object.assign(
                {},
                state.SME.application.table.pagination,
                {
                  page: action.page,
                },
              ),
            }),
          }),
        }),
      });
    case actions.SME_LIST_CHANGE_FILTER:
      return Object.assign({}, state, {
        SME: Object.assign({}, state.SME, {
          application: Object.assign({}, state.SME.application, {
            table: Object.assign({}, state.SME.application.table, {
              currentFilter: Object.assign(
                {},
                state.SME.application.table.currentFilter,
                {
                  ...action.filter,
                },
              ),
            }),
          }),
        }),
      });
    default:
      return state;
  }
}
